import apiService from "apiService";
import React, { useContext, useState, useEffect } from "react";
import Card from "../../../component/Card";
import Form from "../../../component/Form";
import withFormLogic from "../../../hoc/withFormLogic";
import withPostFetch from "../../../hoc/withPostFetch";
import withReference from "../../../hoc/withReference";
import { KunjunganPasienContext } from "view/laporan/Context";

import {
  getWorkAreas,
  getScreeningIlp,
  searchIlpReportCount,
  getClinics,
} from "view/laporan/DataProvider";
import validationRules from "view/laporan/validationRules";
import moment from "moment";

const FilterForm = ({
  field,
  onChangeHandler,
  dateOnChange,
  reactSelectHandler,
  resetField,
  submitHandler,
  post,
  data,
  validation,
  onLoad,
}) => {
  const { insertStore } = useContext(KunjunganPasienContext);
  const [pkm, setpkm] = useState([]);
  console.log(data);
  return (
    <div>
      <Card.SubHeaderWithCollapse header="Filter">
        <Card.Body>
          <Form.Row>
            <Form.Column lg={3} xs={12}>
              <Form.ReactSelect
                label="Screening"
                value={field.screening_id_value}
                name="screening_id"
                placeholder="Pilih..."
                isMulti
                onChange={reactSelectHandler}
                options={data.screening_ilp}
              />
            </Form.Column>
            <Form.Column lg={8} xs={12}>
              <Form.DatePicker
                label="Tanggal mulai"
                size="sm"
                placeholder="dari"
                name="tgl1"
                value={field.tgl1_value}
                onChange={dateOnChange}
              />
              <Form.DatePicker
                label="Tanggal selesai"
                size="sm"
                placeholder="dari"
                name="tgl2"
                value={field.tgl2_value}
                onChange={dateOnChange}
              />
            </Form.Column>
            <Form.Column lg={3} xs={12}>
              <Form.ReactSelect
                label="Klinik"
                options={data.clinics}
                value={field.clinics_value}
                isMulti
                name="clinics"
                placeholder="Pilih..."
                onChange={reactSelectHandler}
              />
            </Form.Column>
          </Form.Row>
          <Form.Row>
            <Form.Column>
              {JSON.parse(localStorage.getItem("userData")).level === 1 ? (
                <Form.Select
                  label="Puskesmas"
                  options={pkm}
                  value={field.puskesmas_id}
                  name="puskesmas_id"
                  placeholder="Pilih..."
                  onChange={onChangeHandler}
                />
              ) : (
                ""
              )}
            </Form.Column>
          </Form.Row>
          <Form.Row>
            <Form.Column lg={3} xs={12}>
              <Form.Select
                label="Desa"
                name="area"
                options={data.work_areas}
                value={field.area}
                onChange={onChangeHandler}
              />
            </Form.Column>
          </Form.Row>
          <Form.Row>
            <Form.Column lg={3} xs={12}>
              <Form.Select
                label="Domisili"
                name="domisili"
                options={data.work_areas}
                value={field.domisili}
                onChange={onChangeHandler}
              />
            </Form.Column>
          </Form.Row>
          <Form.Row>
            <Form.Column lg={2} xs={12}>
              <button
                className="btn btn-primary btn-block"
                disabled={onLoad}
                onClick={() =>
                  submitHandler(validation, field, (params) => {
                    insertStore({ onLoad: true, params });
                    post(params, (response) =>
                      insertStore({ dataKunjungan: response, onLoad })
                    );
                  })
                }
              >
                Tampilkan
              </button>
            </Form.Column>
            <Form.Column lg={2} xs={12}>
              <button
                className="btn btn-secondary btn-block"
                onClick={resetField}
              >
                Reset
              </button>
            </Form.Column>
          </Form.Row>
        </Card.Body>
      </Card.SubHeaderWithCollapse>
    </div>
  );
};

const field = {
  tgl1: moment().format("YYYY-MM-DD"),
  tgl2: moment().format("YYYY-MM-DD"),
  screening_id: [],
  area: "",
  clinics: [],
};

export default withReference(
  [getWorkAreas(), getScreeningIlp(), getClinics()],
  ["work_areas", "screening_ilp", "clinics"]
)(
  withPostFetch((params) => searchIlpReportCount(params))(
    withFormLogic(field, validationRules)(FilterForm)
  )
);
